// AUTO-GENERATED by scripts/gen-stdlib-kinds.mjs from packages/stdlib.
// Do not edit — run the engine build (or the script directly) to regenerate.
//
// Pre-seeded stdlib kind names: the parser uses them for parse-time
// classification heuristics, the resolver as a fallback so files that use
// stdlib kind names without an import still resolve (with EMPTY bodies — an
// imported or locally declared kind always wins and carries its template).

export const STDLIB_INTERFACE_KINDS: ReadonlySet<string> = new Set([
  "amqp",
  "column",
  "db_read",
  "db_write",
  "event",
  "graphql",
  "graphql_mutation",
  "graphql_query",
  "graphql_subscription",
  "grpc",
  "grpc_bidi_stream",
  "grpc_client_stream",
  "grpc_server_stream",
  "grpc_unary",
  "http",
  "http_delete",
  "http_get",
  "http_head",
  "http_options",
  "http_patch",
  "http_post",
  "http_put",
  "kafka",
  "member",
  "mqtt",
  "nats",
  "operation",
  "redis_pubsub",
  "rest",
  "rest_create",
  "rest_delete",
  "rest_list",
  "rest_read",
  "rest_update",
  "sse",
  "webhook",
  "websocket",
]);

export const STDLIB_SURFACE_KINDS: ReadonlySet<string> = new Set([
  "rest_crud",
]);

// Every kind name a stdlib package `export type`s → the package(s) that
// publish it. The LSP auto-import quick-fix maps a bare, unimported stdlib
// kind name (UNKNOWN_TYPE) to its `use <name> from <pkg>` line.
export const STDLIB_KIND_PACKAGES: ReadonlyMap<string, readonly string[]> = new Map([
  ["activemq", ["arch.backend"]],
  ["activiti", ["arch.backend"]],
  ["agent_runtime", ["arch.ai"]],
  ["airbyte", ["arch.data"]],
  ["airflow", ["arch.data"]],
  ["aks", ["arch.cloud.azure"]],
  ["alb", ["arch.cloud.aws"]],
  ["alerting", ["arch.backend"]],
  ["alertmanager", ["arch.backend"]],
  ["alloydb", ["arch.cloud.gcp"]],
  ["amazon_mq", ["arch.cloud.aws"]],
  ["amqp", ["arch.backend"]],
  ["amundsen", ["arch.data"]],
  ["android", ["arch.extras"]],
  ["api", ["arch.c4"]],
  ["api_gateway", ["arch.cloud.aws", "arch.cloud.gcp"]],
  ["api_management", ["arch.cloud.azure"]],
  ["apm", ["arch.backend"]],
  ["app_engine", ["arch.cloud.gcp"]],
  ["app_runner", ["arch.cloud.aws"]],
  ["app_service", ["arch.cloud.azure"]],
  ["application_gateway", ["arch.cloud.azure"]],
  ["arangodb", ["arch.backend"]],
  ["arroyo", ["arch.data"]],
  ["artifact_registry", ["arch.cloud.gcp"]],
  ["atlas", ["arch.data"]],
  ["aurora", ["arch.cloud.aws"]],
  ["authelia", ["arch.backend"]],
  ["authentik", ["arch.backend"]],
  ["aws_opensearch", ["arch.cloud.aws"]],
  ["azure_cdn_profile", ["arch.cloud.azure"]],
  ["azure_dns_zone", ["arch.cloud.azure"]],
  ["azure_files", ["arch.cloud.azure"]],
  ["azure_functions", ["arch.cloud.azure"]],
  ["azure_load_balancer", ["arch.cloud.azure"]],
  ["azure_mysql", ["arch.cloud.azure"]],
  ["azure_postgresql", ["arch.cloud.azure"]],
  ["azure_sql", ["arch.cloud.azure"]],
  ["azure_vm", ["arch.cloud.azure"]],
  ["batch", ["arch.cloud.aws"]],
  ["batch_engine", ["arch.data"]],
  ["bentoml", ["arch.ai"]],
  ["bi_tool", ["arch.data"]],
  ["bigquery", ["arch.cloud.gcp"]],
  ["bigtable", ["arch.cloud.gcp"]],
  ["blob_storage", ["arch.cloud.azure"]],
  ["bpm_system", ["arch.backend"]],
  ["cache", ["arch.backend"]],
  ["cache_for_redis", ["arch.cloud.azure"]],
  ["cadence", ["arch.backend"]],
  ["camunda", ["arch.backend"]],
  ["casdoor", ["arch.backend"]],
  ["cassandra", ["arch.backend"]],
  ["cdn", ["arch.backend", "arch.c4"]],
  ["ceph", ["arch.backend"]],
  ["chroma", ["arch.backend"]],
  ["cilium", ["arch.backend"]],
  ["class", ["arch.diagrams"]],
  ["clickhouse", ["arch.backend"]],
  ["cloud", ["arch.extras"]],
  ["cloud_cdn", ["arch.cloud.gcp"]],
  ["cloud_dns", ["arch.cloud.gcp"]],
  ["cloud_functions", ["arch.cloud.gcp"]],
  ["cloud_load_balancing", ["arch.cloud.gcp"]],
  ["cloud_nat", ["arch.cloud.gcp"]],
  ["cloud_platform", ["arch.c4"]],
  ["cloud_run", ["arch.cloud.gcp"]],
  ["cloud_sql", ["arch.cloud.gcp"]],
  ["cloudfront", ["arch.cloud.aws"]],
  ["cluster", ["arch.c4"]],
  ["cockroachdb", ["arch.backend"]],
  ["collector", ["arch.backend"]],
  ["collibra", ["arch.data"]],
  ["column", ["arch.diagrams"]],
  ["columnar", ["arch.backend"]],
  ["component", ["arch.backend", "arch.c4"]],
  ["conductor", ["arch.backend"]],
  ["consul", ["arch.backend"]],
  ["consul_connect", ["arch.backend"]],
  ["container", ["arch.c4"]],
  ["container_apps", ["arch.cloud.azure"]],
  ["container_boundary", ["arch.c4"]],
  ["container_instance", ["arch.c4"]],
  ["container_instances", ["arch.cloud.azure"]],
  ["container_registry", ["arch.cloud.azure"]],
  ["cortex", ["arch.backend"]],
  ["cosmos_db", ["arch.cloud.azure"]],
  ["couchbase", ["arch.backend"]],
  ["couchdb", ["arch.backend"]],
  ["crewai", ["arch.ai"]],
  ["dagster", ["arch.data"]],
  ["dashboard", ["arch.backend"]],
  ["dask", ["arch.data"]],
  ["data_catalog", ["arch.data"]],
  ["data_explorer", ["arch.cloud.azure"]],
  ["data_lake", ["arch.data"]],
  ["data_pipeline", ["arch.data"]],
  ["data_store", ["arch.c4"]],
  ["database", ["arch.backend"]],
  ["databricks", ["arch.data"]],
  ["dataflow", ["arch.cloud.gcp"]],
  ["datahub", ["arch.data"]],
  ["datastore", ["arch.cloud.gcp"]],
  ["db_read", ["arch.backend"]],
  ["db_write", ["arch.backend"]],
  ["dbt", ["arch.data"]],
  ["debezium", ["arch.data"]],
  ["delta_lake", ["arch.data"]],
  ["department", ["arch.org"]],
  ["deployment_node", ["arch.c4"]],
  ["desktop", ["arch.extras"]],
  ["determined", ["arch.ai"]],
  ["device", ["arch.c4"]],
  ["dex", ["arch.backend"]],
  ["dgraph", ["arch.backend"]],
  ["dns", ["arch.c4"]],
  ["document", ["arch.backend"]],
  ["documentdb", ["arch.cloud.aws"]],
  ["dremio", ["arch.data"]],
  ["druid", ["arch.backend"]],
  ["duckdb", ["arch.backend"]],
  ["dynamodb", ["arch.cloud.aws"]],
  ["ebs", ["arch.cloud.aws"]],
  ["ec2", ["arch.cloud.aws"]],
  ["ecr", ["arch.cloud.aws"]],
  ["ecs", ["arch.cloud.aws"]],
  ["efs", ["arch.cloud.aws"]],
  ["eks", ["arch.cloud.aws"]],
  ["elasticache", ["arch.cloud.aws"]],
  ["elasticsearch", ["arch.backend"]],
  ["elb", ["arch.cloud.aws"]],
  ["enterprise_boundary", ["arch.c4"]],
  ["enum", ["arch.diagrams"]],
  ["etcd", ["arch.backend"]],
  ["eureka", ["arch.backend"]],
  ["event", ["arch.backend"]],
  ["event_grid", ["arch.cloud.azure"]],
  ["event_hubs", ["arch.cloud.azure"]],
  ["eventarc", ["arch.cloud.gcp"]],
  ["eventbridge", ["arch.cloud.aws"]],
  ["execution_environment", ["arch.c4"]],
  ["external_person", ["arch.c4"]],
  ["external_software_system", ["arch.c4"]],
  ["external_system", ["arch.backend"]],
  ["fargate", ["arch.cloud.aws"]],
  ["feast", ["arch.ai"]],
  ["feature_flags", ["arch.backend"]],
  ["feature_store", ["arch.ai"]],
  ["file_system", ["arch.c4"]],
  ["filestore", ["arch.cloud.gcp"]],
  ["final_state", ["arch.diagrams"]],
  ["firebolt", ["arch.data"]],
  ["firestore", ["arch.cloud.gcp"]],
  ["firewall", ["arch.c4"]],
  ["fivetran", ["arch.data"]],
  ["flagsmith", ["arch.backend"]],
  ["flink", ["arch.data"]],
  ["flipt", ["arch.backend"]],
  ["flowable", ["arch.backend"]],
  ["fluent_bit", ["arch.backend"]],
  ["fluentd", ["arch.backend"]],
  ["flyte", ["arch.ai"]],
  ["front_door", ["arch.cloud.azure"]],
  ["frontend", ["arch.backend"]],
  ["fsx", ["arch.cloud.aws"]],
  ["fusionauth", ["arch.backend"]],
  ["garage", ["arch.backend"]],
  ["gateway", ["arch.backend", "arch.c4"]],
  ["gce", ["arch.cloud.gcp"]],
  ["gcs", ["arch.cloud.gcp"]],
  ["gke", ["arch.cloud.gcp"]],
  ["glitchtip", ["arch.backend"]],
  ["grafana", ["arch.backend"]],
  ["graph_db", ["arch.backend"]],
  ["graphite", ["arch.backend"]],
  ["graphql", ["arch.backend"]],
  ["graphql_mutation", ["arch.backend"]],
  ["graphql_query", ["arch.backend"]],
  ["graphql_subscription", ["arch.backend"]],
  ["graylog", ["arch.backend"]],
  ["growthbook", ["arch.backend"]],
  ["grpc", ["arch.backend"]],
  ["grpc_bidi_stream", ["arch.backend"]],
  ["grpc_client_stream", ["arch.backend"]],
  ["grpc_server_stream", ["arch.backend"]],
  ["grpc_unary", ["arch.backend"]],
  ["guild", ["arch.org"]],
  ["hadoop", ["arch.data"]],
  ["hazelcast", ["arch.backend"]],
  ["hbase", ["arch.backend"]],
  ["hivemq", ["arch.backend"]],
  ["hopsworks", ["arch.ai"]],
  ["host", ["arch.c4"]],
  ["http", ["arch.backend"]],
  ["http_delete", ["arch.backend"]],
  ["http_get", ["arch.backend"]],
  ["http_head", ["arch.backend"]],
  ["http_options", ["arch.backend"]],
  ["http_patch", ["arch.backend"]],
  ["http_post", ["arch.backend"]],
  ["http_put", ["arch.backend"]],
  ["hudi", ["arch.data"]],
  ["hyperscale", ["arch.backend"]],
  ["ibm_mq", ["arch.backend"]],
  ["iceberg", ["arch.data"]],
  ["identity_provider", ["arch.backend"]],
  ["infisical", ["arch.backend"]],
  ["influxdb", ["arch.backend"]],
  ["infrastructure_node", ["arch.c4"]],
  ["ingestion", ["arch.data"]],
  ["initial_state", ["arch.diagrams"]],
  ["iphone", ["arch.extras"]],
  ["istio", ["arch.backend"]],
  ["jaeger", ["arch.backend"]],
  ["janusgraph", ["arch.backend"]],
  ["jupyter", ["arch.data"]],
  ["kafka", ["arch.backend"]],
  ["kafka_cluster", ["arch.backend"]],
  ["kafka_connect", ["arch.data"]],
  ["kafka_streams", ["arch.data"]],
  ["karma", ["arch.backend"]],
  ["kestra", ["arch.data"]],
  ["keycloak", ["arch.backend"]],
  ["keydb", ["arch.backend"]],
  ["keyspaces", ["arch.cloud.aws"]],
  ["kibana", ["arch.backend"]],
  ["kinesis", ["arch.cloud.aws"]],
  ["kinesis_firehose", ["arch.cloud.aws"]],
  ["kserve", ["arch.ai"]],
  ["ksqldb", ["arch.data"]],
  ["kubeflow", ["arch.ai"]],
  ["kuma", ["arch.backend"]],
  ["kv_store", ["arch.backend"]],
  ["lakehouse", ["arch.data"]],
  ["lambda", ["arch.cloud.aws"]],
  ["lancedb", ["arch.backend"]],
  ["langgraph", ["arch.ai"]],
  ["laptop", ["arch.extras"]],
  ["lightsail", ["arch.cloud.aws"]],
  ["linkerd", ["arch.backend"]],
  ["litellm", ["arch.ai"]],
  ["llm_gateway", ["arch.ai"]],
  ["load_balancer", ["arch.backend", "arch.c4"]],
  ["logging_system", ["arch.backend"]],
  ["logstash", ["arch.backend"]],
  ["loki", ["arch.backend"]],
  ["looker", ["arch.data"]],
  ["m3db", ["arch.backend"]],
  ["mage", ["arch.data"]],
  ["managed_disk", ["arch.cloud.azure"]],
  ["managed_kafka", ["arch.cloud.gcp"]],
  ["mariadb", ["arch.backend"]],
  ["materialize", ["arch.data"]],
  ["meilisearch", ["arch.backend"]],
  ["meltano", ["arch.data"]],
  ["member", ["arch.diagrams"]],
  ["memcached", ["arch.backend"]],
  ["memorydb", ["arch.cloud.aws"]],
  ["memorystore", ["arch.cloud.gcp"]],
  ["message_broker", ["arch.backend"]],
  ["message_bus", ["arch.c4"]],
  ["metabase", ["arch.data"]],
  ["metaflow", ["arch.ai"]],
  ["metrics_system", ["arch.backend"]],
  ["milvus", ["arch.backend"]],
  ["mimir", ["arch.backend"]],
  ["minio", ["arch.backend"]],
  ["mlflow", ["arch.ai"]],
  ["mobile_app", ["arch.c4"]],
  ["model_registry", ["arch.ai"]],
  ["model_server", ["arch.ai"]],
  ["mongodb", ["arch.backend"]],
  ["mosquitto", ["arch.backend"]],
  ["motherduck", ["arch.data"]],
  ["mqtt", ["arch.backend"]],
  ["mqtt_broker", ["arch.backend"]],
  ["msk", ["arch.cloud.aws"]],
  ["mssql", ["arch.backend"]],
  ["mysql", ["arch.backend"]],
  ["n8n", ["arch.backend"]],
  ["nacos", ["arch.backend"]],
  ["nat_gateway", ["arch.cloud.aws"]],
  ["nats", ["arch.backend"]],
  ["nats_server", ["arch.backend"]],
  ["neo4j", ["arch.backend"]],
  ["neptune", ["arch.ai", "arch.cloud.aws"]],
  ["nifi", ["arch.data"]],
  ["nlb", ["arch.cloud.aws"]],
  ["note", ["arch.diagrams"]],
  ["notebook", ["arch.data"]],
  ["nsq", ["arch.backend"]],
  ["object_storage", ["arch.backend"]],
  ["observability", ["arch.backend"]],
  ["ollama", ["arch.ai"]],
  ["openbao", ["arch.backend"]],
  ["openmetadata", ["arch.data"]],
  ["opensearch", ["arch.backend"]],
  ["operation", ["arch.diagrams"]],
  ["oracle", ["arch.backend"]],
  ["ory", ["arch.backend"]],
  ["otel_collector", ["arch.backend"]],
  ["persistent_disk", ["arch.cloud.gcp"]],
  ["person", ["arch.c4"]],
  ["pinot", ["arch.backend"]],
  ["portkey", ["arch.ai"]],
  ["postgres", ["arch.backend"]],
  ["powerbi", ["arch.data"]],
  ["prefect", ["arch.data"]],
  ["presto", ["arch.data"]],
  ["prometheus", ["arch.backend"]],
  ["pubsub", ["arch.cloud.gcp"]],
  ["pubsub_lite", ["arch.cloud.gcp"]],
  ["pulsar", ["arch.backend"]],
  ["pyroscope", ["arch.backend"]],
  ["qdrant", ["arch.backend"]],
  ["query_engine", ["arch.data"]],
  ["questdb", ["arch.backend"]],
  ["queue", ["arch.backend"]],
  ["queue_storage", ["arch.cloud.azure"]],
  ["rabbitmq", ["arch.backend"]],
  ["rate_limiter", ["arch.backend"]],
  ["ray", ["arch.data"]],
  ["ray_serve", ["arch.ai"]],
  ["rds", ["arch.cloud.aws"]],
  ["redash", ["arch.data"]],
  ["redis", ["arch.backend"]],
  ["redis_pubsub", ["arch.backend"]],
  ["redis_streams", ["arch.backend"]],
  ["redpanda", ["arch.backend"]],
  ["redshift", ["arch.cloud.aws"]],
  ["region", ["arch.c4"]],
  ["relational", ["arch.backend"]],
  ["rest", ["arch.backend"]],
  ["rest_create", ["arch.backend"]],
  ["rest_crud", ["arch.backend"]],
  ["rest_delete", ["arch.backend"]],
  ["rest_list", ["arch.backend"]],
  ["rest_read", ["arch.backend"]],
  ["rest_update", ["arch.backend"]],
  ["risingwave", ["arch.data"]],
  ["route53", ["arch.cloud.aws"]],
  ["s3", ["arch.cloud.aws"]],
  ["s3_glacier", ["arch.cloud.aws"]],
  ["scylladb", ["arch.backend"]],
  ["search_index", ["arch.backend"]],
  ["seaweedfs", ["arch.backend"]],
  ["secrets_manager", ["arch.backend"]],
  ["sentry", ["arch.backend"]],
  ["server", ["arch.extras"]],
  ["serverless_function", ["arch.c4"]],
  ["service", ["arch.backend"]],
  ["service_bus", ["arch.cloud.azure"]],
  ["service_discovery", ["arch.backend"]],
  ["service_mesh", ["arch.backend"]],
  ["sglang", ["arch.ai"]],
  ["signoz", ["arch.backend"]],
  ["single_page_app", ["arch.c4"]],
  ["skywalking", ["arch.backend"]],
  ["smartphone", ["arch.extras"]],
  ["snowflake", ["arch.data"]],
  ["sns", ["arch.cloud.aws"]],
  ["software_system", ["arch.c4"]],
  ["solr", ["arch.backend"]],
  ["spanner", ["arch.cloud.gcp"]],
  ["spark", ["arch.data"]],
  ["spark_streaming", ["arch.data"]],
  ["sql_managed_instance", ["arch.cloud.azure"]],
  ["sqlite", ["arch.backend"]],
  ["sqlmesh", ["arch.data"]],
  ["sqs", ["arch.cloud.aws"]],
  ["sse", ["arch.backend"]],
  ["starrocks", ["arch.data"]],
  ["state", ["arch.diagrams"]],
  ["storage_gateway", ["arch.cloud.aws"]],
  ["stream_processor", ["arch.data"]],
  ["superset", ["arch.data"]],
  ["supertokens", ["arch.backend"]],
  ["synapse", ["arch.cloud.azure"]],
  ["system", ["arch.backend"]],
  ["system_boundary", ["arch.c4"]],
  ["table", ["arch.diagrams"]],
  ["table_storage", ["arch.cloud.azure"]],
  ["tableau", ["arch.data"]],
  ["tablet", ["arch.extras"]],
  ["tarantool", ["arch.backend"]],
  ["team", ["arch.org"]],
  ["tecton", ["arch.ai"]],
  ["telegraf", ["arch.backend"]],
  ["tempo", ["arch.backend"]],
  ["temporal", ["arch.backend"]],
  ["tf_serving", ["arch.ai"]],
  ["tgi", ["arch.ai"]],
  ["thanos", ["arch.backend"]],
  ["tigergraph", ["arch.backend"]],
  ["timescaledb", ["arch.backend"]],
  ["timeseries", ["arch.backend"]],
  ["timestream", ["arch.cloud.aws"]],
  ["torchserve", ["arch.ai"]],
  ["tracing_system", ["arch.backend"]],
  ["traffic_manager", ["arch.cloud.azure"]],
  ["training_platform", ["arch.ai"]],
  ["transform_tool", ["arch.data"]],
  ["trino", ["arch.data"]],
  ["triton", ["arch.ai"]],
  ["typesense", ["arch.backend"]],
  ["unleash", ["arch.backend"]],
  ["user", ["arch.extras"]],
  ["usergroup", ["arch.extras"]],
  ["vault", ["arch.backend"]],
  ["vector", ["arch.backend"]],
  ["vector_agent", ["arch.backend"]],
  ["victoriametrics", ["arch.backend"]],
  ["vitess", ["arch.backend"]],
  ["vllm", ["arch.ai"]],
  ["vm_scale_sets", ["arch.cloud.azure"]],
  ["vnet", ["arch.cloud.azure"]],
  ["vpc", ["arch.cloud.aws", "arch.cloud.gcp"]],
  ["waf", ["arch.backend"]],
  ["wandb", ["arch.ai"]],
  ["warehouse", ["arch.data"]],
  ["weaviate", ["arch.backend"]],
  ["web_application", ["arch.c4"]],
  ["webhook", ["arch.backend"]],
  ["webpage", ["arch.extras"]],
  ["websocket", ["arch.backend"]],
  ["worker", ["arch.backend"]],
  ["ydb", ["arch.backend"]],
  ["zeebe", ["arch.backend"]],
  ["zeppelin", ["arch.data"]],
  ["zipkin", ["arch.backend"]],
  ["zitadel", ["arch.backend"]],
  ["zookeeper", ["arch.backend"]],
]);
